




$(document).ready(function (){

  $(".main-slider").slick({
     slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      asNavFor: '.nav-slider',
      infinte: true,
      responsive: [
       {
            breakpoint: 767,
            settings: {
                dots: true,
                arrows: false
            }
        }
      ]
  });

  $(".nav-slider").slick({
    slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true,
      asNavFor: '.main-slider',
      infinte: true
  });


   $('.main-slider').on('beforeChange', function(event,slick,slide,nextSlide) {
        $('.nav-slider').find('.slick-slide').removeClass('slick-current').eq(nextSlide).addClass('slick-current');
    });


    if($(".suplement_facts_image_box .right-slider").length) { 
      
      $(".suplement_facts_image_box .right-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinte: true
      });
      
    }



    $(".reviews-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: false,
        infinte: true
    });

  
});